angular.module('document')
    .component('documentPriorityStar', {
        bindings: {
            priority: '<'
        },
        controller: function ($element) {
            this.$onChanges = () => {
                const hasPriority = this.priority != null && this.priority !== 'LOW';
                $element.css('display', hasPriority ? '' : 'none');
            };
        },
        template: `
            <span class="document-info-header">
                <i class="fa fa-fw fa-star document-priority-{{$ctrl.priority}}" title="Priorytet: {{ 'document.priority.' + $ctrl.priority | translate}}"></i>
            </span>
        `
    })
